import { createIcon } from '@chakra-ui/icons';

export const CircleWaveform = createIcon({
  displayName: 'CircleWaveform',
  viewBox: '0 0 16 16',
  path: [
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.4126 9.18466L1.79639 9.18463C2.28787 9.1846 2.7433 8.92672 2.99616 8.50528L3.05706 8.40379C3.64801 7.41888 5.11101 7.5361 5.53759 8.60255C6.02897 9.83098 7.79689 9.74176 8.1621 8.4701L8.81249 6.20539C9.17678 4.93693 10.9335 4.83169 11.4466 6.04759L12.4095 8.32934C12.6282 8.84765 13.1361 9.18458 13.6987 9.18458H14.2206"
        stroke="currentColor"
        strokeWidth="1.55167"
        strokeMiterlimit="10"
      />
      <path
        d="M7.77588 14.7758C11.6419 14.7758 14.7759 11.6418 14.7759 7.77583C14.7759 3.90984 11.6419 0.775833 7.77588 0.775833C3.90989 0.775833 0.775879 3.90984 0.775879 7.77583C0.775879 11.6418 3.90989 14.7758 7.77588 14.7758Z"
        stroke="currentColor"
        strokeWidth="1.55167"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>,
  ],
});
